<template>
    <span v-html="localized"></span>
</template>

<script>
  //import strings from '../strings.js';
  export default {
    name: "localizedString",
    props: {
      val: {required: true, type: String}
    },
    computed: {
      localized() {
        let strings = this.$strings;
        let key = this.val;
        if (strings[key] === undefined) {
          console.log("No string found for key '" + key + "'")
          return "";
        } else {
          return this.$sanitize(strings[key], {allowedTags: ['br', 'i', 'strong']});
        }
      }
    }
  }
</script>

<style scoped>

</style>
